export default __webpack_public_path__ + "static/media/ca-continue.fab4cac3.jpg";